<div class="navbar no-print">
  <div class="logo-container">
    <div class="logo mark-down" (click)="goHome()"></div>
    <!--<div class="logo"><a [routerLink]="homeUrl" routerLinkActive="active"></a></div>-->
    <div class="navbar-title">{{ dataSource.title }}</div>
  </div>
  <div class="divider"></div>
  <div class="option-menu">
    <div
      class="menu-item"
      *ngFor="let item of dataSource.data; trackBy: trackByFn"
      (click)="menuClick(item.type)"
      (mouseleave)="mouseLeave(item.type)"
      [ngClass]="{ alerted: item.type == 'alert' }"
    >
      <div class="nav-menu-wrapper" [ngSwitch]="item.type">
        <div *ngSwitchCase="'navigation'" class="title" (click)="onClickEvent(item)">
          {{ item.title }}
        </div>
        <div *ngSwitchCase="'settings'" class="settings" (click)="onClickEvent(item)">
          <i class="material-icons icon">settings</i>
          <div class="title">{{ item.title }}</div>
          <i class="material-icons carret">arrow_drop_down</i>
        </div>
        <div #helpMenu *ngSwitchCase="'help'" class="nav-help" (click)="toggleHelpMenu(true)">
          <i class="material-icons icon">help_outline</i>
          <div class="title">{{ item.title }}</div>
          <mat-icon class="carret">arrow_drop_down</mat-icon>
        </div>
        <div *ngSwitchCase="'user'" class="user">
          <div class="user-greeting">Hello, {{ userService.getUserName() }}</div>
          <i class="mdi mdi-account"></i>
          <mat-icon class="carret">arrow_drop_down</mat-icon>
        </div>
        <div *ngSwitchCase="'chat'" class="chat" (click)="showLiveChat()">
          <i class="material-icons icon">chat_bubble_outline</i>
          <div class="title">{{ item.title }}</div>
        </div>
      </div>

      <div
        class="sub-menu"
        *ngIf="showSubmenu[item.type] && item.menuItems && item.menuItems.length > 0"
      >
        <div class="tooltip-styling"></div>
        <div *ngFor="let menu of item.menuItems">
          <div
            class="sub-menu-item"
            *ngIf="isVisibleSubMenu(menu)"
            (click)="$event.stopPropagation(); onClickEvent(menu, item.type)"
            [ngSwitch]="menu.id"
          >
            <!--  TO-DO Replace with original icon -->
            <i class="material-icons icon mdi mdi-pulse" *ngSwitchCase="'monitor_management'"></i>
            <mat-icon
              class="mdi mdi-television-guide icon cloud"
              *ngSwitchCase="'applications'"
            ></mat-icon>
            <i class="material-icons icon mdi mdi-city-variant-outline" *ngSwitchCase="'sites'"></i>
            <i class="material-icons icon" *ngSwitchCase="'datasource_management'"
              >perm_data_setting</i
            >
            <i class="icon mdi mdi-map-marker" *ngSwitchCase="'endpoints_management'"></i>
            <i class="icon mdi mdi-upload" *ngSwitchCase="'uploads'"></i>
            <i class="icon mdi mdi-download" *ngSwitchCase="'downloads'"></i>
            <i class="icon mdi mdi-poll" *ngSwitchCase="'reports_setting'"></i>
            <i class="material-icons icon" *ngSwitchCase="'logs'">library_books</i>
            <i class="material-icons icon" *ngSwitchCase="'reports'">assignment</i>
            <i class="material-icons icon" *ngSwitchCase="'users_groups'">supervisor_account</i>
            <i class="material-icons icon" *ngSwitchCase="'trap_receivers'"
              >notification_important</i
            >
            <i class="material-icons icon" *ngSwitchCase="'syslog_config'">settings_applications</i>
            <i class="material-icons icon" *ngSwitchCase="'settings'">add_alert</i>
            <i class="material-icons icon" *ngSwitchCase="'billing'">description</i>
            <i class="material-icons icon" *ngSwitchCase="'about'">info_outline</i>
            <i class="material-icons icon" *ngSwitchCase="'thresholds_setting'">tune</i>
            <i class="material-icons icon" *ngSwitchCase="'help'">help_outline</i>
            <i class="icon mdi mdi-email" *ngSwitchCase="'email'"></i>
            <i class="icon mdi mdi-layers-plus" *ngSwitchCase="'dashboard-library'"></i>
            <i class="icon mdi mdi-book-multiple" *ngSwitchCase="'licenses'"></i>
            <i class="icon mdi mdi-chart-bell-curve" *ngSwitchCase="'profile_exceptions'"></i>
            <i class="icon mdi mdi-web-box" *ngSwitchCase="'dmz_server'"></i>
            <div class="title">{{ menu.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="shouldShowHelp" class="help-menu-container" #menu>
      <help-menu-dialog
        [filePath]="filePath"
        (clickCloseButton)="toggleHelpMenu($event)"
      ></help-menu-dialog>
    </div>
  </div>
</div>
